import React from "react"
import { Link } from "react-router-dom"

const ListingCard = ({ listing, isSaved = false, onToggleSave }) => {
  const { cover, category, location, name, price, type } = listing
  const handleWishlistClick = (e) => {
    e.preventDefault()
    e.stopPropagation()
    if (onToggleSave) onToggleSave(listing.id)
  }
  return (
    <article className='listing-card'>
      <div className='listing-card__img-wrap'>
        <img src={cover} alt={name} className='listing-card__img' />
        <span
          className='listing-card__badge'
          style={{
            background: category === "For Sale" ? "#25b579" : "#ff9800",
            color: "#ffffff",
          }}
        >
          {category}
        </span>
        <button
          type='button'
          className={`listing-card__wishlist ${isSaved ? "listing-card__wishlist--saved" : ""}`}
          aria-label={isSaved ? "Remove from list" : "Save to list"}
          onClick={handleWishlistClick}
        >
          <i className='fa fa-heart'></i>
        </button>
      </div>
      <div className='listing-card__body'>
        <h3 className='listing-card__title'>
          <Link to={`/listings/${listing.id}`}>{name}</Link>
        </h3>
        <p className='listing-card__location'>
          <i className='fa fa-location-dot'></i> {location}
        </p>
        <p className='listing-card__type'>{type}</p>
      </div>
      <div className='listing-card__footer'>
        <div className='listing-card__price'>
          <strong>{price}</strong>
          {category === "For Rent" && <span className='listing-card__price-unit'>/month</span>}
        </div>
        <Link to={`/listings/${listing.id}`} className='listing-card__cta'>
          View details
        </Link>
      </div>
    </article>
  )
}

export default ListingCard
